import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@shared/ui/dialog";

interface MeterReplacementHowItWorksDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const MeterReplacementHowItWorksDialog = ({
  open,
  onOpenChange,
}: MeterReplacementHowItWorksDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Meter Replacement – Billing Actions</DialogTitle>
        </DialogHeader>

        <div className="space-y-6 py-4">
          <p className="text-sm text-gray-600">
            When a meter is replaced during a billing cycle, the system allows
            the utility to choose how bills and consumption are handled.
          </p>

          {/* Option 1 */}
          <div>
            <h3 className="font-semibold text-base mb-2 text-blue-600">
              1. Separate Bill
            </h3>
            <ul className="list-disc list-inside space-y-1 text-sm text-gray-700 ml-4">
              <li>
                <strong>Bill 1:</strong> Last billing date → replacement date
              </li>
              <li>
                <strong>Bill 2:</strong> Replacement date → current billing date
              </li>
            </ul>
            <p className="text-sm text-gray-600 mt-2">
              Each bill is calculated and validated independently.
            </p>
          </div>

          {/* Option 2 */}
          <div>
            <h3 className="font-semibold text-base mb-2 text-blue-600">
              2. Separate Consumption on a Single Bill
            </h3>
            <ul className="list-disc list-inside space-y-1 text-sm text-gray-700 ml-4">
              <li>Old meter consumption</li>
              <li>New meter consumption</li>
            </ul>
            <div className="bg-gray-100 p-3 rounded mt-2 font-mono text-xs">
              Total = Old meter + New meter
            </div>
          </div>

          {/* Option 3 */}
          <div>
            <h3 className="font-semibold text-base mb-2 text-blue-600">
              3. Cumulative Consumption on a Single Bill
            </h3>
            <div className="bg-gray-100 p-3 rounded mt-2 font-mono text-xs space-y-1">
              <p>Old = Final reading − Previous reading</p>
              <p>New = Current reading − Initial reading</p>
            </div>
            <p className="text-sm text-gray-600 mt-2">
              Only one combined consumption value appears on the bill.
            </p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
